import type { MouseEvent, ReactNode } from "react";
import { prefersReducedMotion } from "../motion";

// A real <a href="#id"> that smooth-scrolls to an in-page section when it exists on the
// current page (home), and otherwise behaves as a normal anchor. Used by header + footer.
export function SectionLink({
  id,
  children,
  className = "",
  onNavigate,
  current,
}: {
  id: string;
  children: ReactNode;
  className?: string;
  onNavigate?: () => void;
  /** Marks the link as the active scroll-spy section (aria-current). */
  current?: boolean;
}) {
  const handle = (e: MouseEvent<HTMLAnchorElement>) => {
    const el = typeof document !== "undefined" ? document.getElementById(id) : null;
    if (el) {
      e.preventDefault();
      el.scrollIntoView({ behavior: prefersReducedMotion() ? "auto" : "smooth", block: "start" });
    }
    onNavigate?.();
  };
  return (
    <a
      href={`#${id}`}
      className={className || undefined}
      aria-current={current ? "true" : undefined}
      onClick={handle}
    >
      {children}
    </a>
  );
}
